import { useEffect, useState } from "react";
import { useNavigate,useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import printerimg from "../../../../assets/print.png";
import { useGetItemDetailsDataMutation } from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import FileAttachmentManagerViewPage  from "../../../../Components/FileAttachmentManagerViewPage";
import Attachment from "../../../../utils/Attachment";
const ViewForm = () => {
  const navigate = useNavigate();
   const location = useLocation();
        const IdData = location.state?.ItemId;
        const [podata, setpodata] = useState('')
  const [tab, settab] = useState(1);
  const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
  const [error, setError] = useState("");
  const [ptype, setptype] = useState("Error");
  const [finalstep, setfinalstep] = useState(false);
  const [showError, setShowError] = useState(false);

 

  // tab1
    const [ModeofPayment_list, setModeofPayment_list] = useState([]);
  const [select_ModeofPayment, setselect_ModeofPayment] = useState("");
    const [DueDateBasedOn_list, setDueDateBasedOn_list] = useState([]);
  const [select_DueDateBasedOn, setselect_DueDateBasedOn] = useState("");
  const [PaymentTermName, setPaymentTermName] = useState("");
  const [CreditDays, setCreditDays] = useState("");
  
    const [DiscountType_list, setDiscountType_list] = useState([]);
  const [select_DiscountType, setselect_DiscountType] = useState("");
  const [InvoicePortion, setInvoicePortion] = useState("");

  
  const [Discount, setDiscount] = useState("");
   const [DiscountValidityBasedOn, setDiscountValidityBasedOn] = useState("");
    const [DiscountValidity, setDiscountValidity] = useState("");
  const [Description, setDescription] = useState("");

  const [po_response, setpo_response] = useState("");

  const [fieldErrors, setFieldErrors] = useState({
   ModeofPayment: false,
      DueDateBasedOn: false,
      CreditDays: false,
      Discount: false,
      DiscountType: false,
  });
    const [DiscountType, setDiscountType] = useState("");
    const [DueDateBasedOn, setDueDateBasedOn] = useState("");
const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
 const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

    useEffect(() => {
        if (IdData) {
            itemDetails({ doctype: 'Payment Term', name: IdData })
                .unwrap()
                .then((response) => {
                   const item = response.docs?.[0]; // ✅ safely access first item
  const docinfo = response.docinfo;

  if (!item) return;
                    setpodata(response)
                   console.log(item, "Api response");
                    setselect_ModeofPayment(item.mode_of_payment);
                    setInvoicePortion(item.invoice_portion)
                    setDueDateBasedOn(item.due_date_based_on);
                    setselect_DueDateBasedOn(item.due_date_based_on);
                    setPaymentTermName(item.payment_term_name);
                    setCreditDays(item.credit_days)

                    setselect_DiscountType(item.discount_type)
                    setDiscountType(item.discount_type)
                    setDiscount(item.discount)
                    setDiscountValidityBasedOn(item.discount_validity_based_on)
                    setDiscountValidity(item.discount_validity)
                    setDescription(item.description)
                     setAttachmentsList(docinfo.attachments); // ✅ Correct place
                    
                   
                })
                .catch((err) => {
                    console.error('API Error:', err);
                });
        } else {
            console.warn('No Id Data found in location state');
        }
    }, [IdData, itemDetails]);


  
  return (
    <FormLayout
      title="View Payment Term"
       breadcrumbs={[
        { label: "Payment Term"},
        { label: "Payment Term List", url: "/master/payment-term/payment-term-list" },
      ]}
      status={'hide'}
      finalStep={finalstep}
      actionButtons={
        <>
          

          <Button
            to="/"
            className="px-2"
            imgSrc={printerimg}
            imgStyle={{ width: "21px" }}
          />
        </>
      }
    >
      <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
        <div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
          <div className="d-flex justify-content-between align-items-end ">
            <ul
              className="nav nav-tabs"
              style={{ color: "white", border: "none" }}
            >
              <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                <a
                  className={
                    tab == 1
                      ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
                      : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
                  }
                  onClick={() => {
                    settab(1);
                  }}
                  href="javascript:void(0);"
                >
                  General Details
                  {tab == 1 ? (
                    <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                  ) : (
                    <GetIcon iconName="MdKeyboardArrowRight" size={15} />
                  )}
                </a>
              </li>
            </ul>
         <Attachment doctype="Payment Term"  docname={IdData}  />    

          </div>
        </div>

        <div
          className="mt-2"
          style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}
        >
          <div
            className="mt-2 py-2"
            style={{
              width: "100%",
              overflow: "hidden",
              backgroundColor: "#fff",
            }}
          >
            <div className="row d-flex justify-content-between">
              <div className="col-12">
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1
                  IdData={IdData}
                      ModeofPayment={{ ModeofPayment_list: ModeofPayment_list, setselect_ModeofPayment: setselect_ModeofPayment, select_ModeofPayment: select_ModeofPayment, Error: fieldErrors.ModeofPayment }}
                    
  DueDateBasedOn={{ DueDateBasedOn_list: DueDateBasedOn_list, setselect_DueDateBasedOn: setselect_DueDateBasedOn, select_DueDateBasedOn: select_DueDateBasedOn, Error: fieldErrors.DueDateBasedOn }}
                    PaymentTermName={{
                      PaymentTermName: PaymentTermName,
                      setPaymentTermName: setPaymentTermName,
                      PaymentTermName: PaymentTermName,
                      Error: fieldErrors.PaymentTermName,
                    }}
                    CreditDays={{
                      CreditDays: CreditDays,
                      setCreditDays: setCreditDays,
                      CreditDays: CreditDays,
                      Error: fieldErrors.CreditDays,
                    }}
                     
                      DiscountType={{ DiscountType_list: DiscountType_list, setselect_DiscountType: setselect_DiscountType, select_DiscountType: select_DiscountType, Error: fieldErrors.DiscountType }}
                     
                    InvoicePortion={{
                      InvoicePortion: InvoicePortion,
                      setInvoicePortion: setInvoicePortion,
                      InvoicePortion: InvoicePortion,
                      Error: fieldErrors.InvoicePortion,
                    }}
                    Discount={{
                      Discount: Discount,
                      setDiscount: setDiscount,
                      Discount: Discount,
                      Error: fieldErrors.Discount,
                    }}
                    DiscountValidity={{
                      DiscountValidity: DiscountValidity,
                      setDiscountValidity: setDiscountValidity,
                      DiscountValidity: DiscountValidity,
                      Error: fieldErrors.DiscountValidity,
                    }}
                    DiscountValidityBasedOn={{
                      DiscountValidityBasedOn: DiscountValidityBasedOn,
                      setDiscountValidityBasedOn: setDiscountValidityBasedOn,
                      DiscountValidityBasedOn: DiscountValidityBasedOn,
                      Error: fieldErrors.DiscountValidityBasedOn,
                    }}
                    Description={{
                      Description: Description,
                      setDescription: setDescription,
                      Description: Description,
                      Error: fieldErrors.Description,
                    }}
                    
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApiResponseBox
        poptype={ptype}
        show={showError}
        errorMessage={error}
        onClose={() => setShowError(false)}
      />
    </FormLayout>
  );
};

export default ViewForm;
